import { SUPER_MINTER_ABI, SUPER_MINTER_ADDRESS } from '../../abi/super-minter.mjs';

async function getPlatformFees(client, { platform, tiers }) {
  return client.multicall({
    contracts: tiers.map((tier) => ({
      abi: SUPER_MINTER_ABI,
      address: SUPER_MINTER_ADDRESS,
      functionName: "platformFeeConfig",
      args: [platform, tier]
    })),
    allowFailure: false
  });
}

export { getPlatformFees };
